import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function NewsletterList() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/newsletter").then(({ data }) => setSubs(data)).catch(() => {}); }, []);

  const exportCsv = () => {
    const rows = [["email", "tarih", "kvkk"], ...subs.map((s) => [s.email, (s.created_at || "").slice(0, 10), s.kvkk])];
    const csv = rows.map((r) => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob); a.download = "bilgece-mektup.csv"; a.click();
  };

  return (
    <div data-testid="admin-newsletter">
      <div className="flex justify-between items-center mb-6">
        <h1 className="font-serif text-4xl text-brand-green">Bilgece Mektup ({subs.length})</h1>
        <button onClick={exportCsv} data-testid="newsletter-export" className="bg-brand-gold text-brand-offwhite px-5 py-2.5 rounded-sm text-sm">CSV İndir</button>
      </div>
      <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-brand-cream text-brand-green text-left"><tr><th className="p-3 font-medium">E-posta</th><th className="p-3 font-medium">Kayıt Tarihi</th><th className="p-3 font-medium">KVKK</th></tr></thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-t border-brand-gold-light/30">
                <td className="p-3 text-brand-green">{s.email}</td>
                <td className="p-3 text-brand-text/60">{(s.created_at || "").slice(0, 10)}</td>
                <td className="p-3">{s.kvkk ? "✓" : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {subs.length === 0 && <p className="p-6 text-brand-text/50 text-sm">Henüz abone yok.</p>}
      </div>
    </div>
  );
}
